/** Outcode: area letters + 1–2 digits + optional letter. Matches analytics.ts. */
const UK_OUTCODE_RE = /^[A-Z]{1,2}[0-9][0-9A-Z]?$/;
/** Inward code is always digit + two letters. */
const UK_INWARD_RE = /^[0-9][A-Z]{2}$/;

/**
 * True when `value` is a complete UK postcode (outcode + inward, optional space).
 * Incomplete outward-only values such as "SW1A" or "BN11A" return false.
 */
export function isValidUkPostcode(value: string): boolean {
  const cleaned = value.toUpperCase().replace(/\s+/g, "").trim();
  if (cleaned === "GIR0AA") return true;
  if (cleaned.length < 5 || cleaned.length > 7) return false;

  const inward = cleaned.slice(-3);
  const outcode = cleaned.slice(0, -3);
  return UK_OUTCODE_RE.test(outcode) && UK_INWARD_RE.test(inward);
}
